import getConfig from 'next/config';
import {
  getCookie,
  getCookieValue,
  setCookie,
} from '../../util/cookies';

const {
  publicRuntimeConfig: {
    GF_DOTCOM_ENV,
    GF_DOTCOM_SHOPIFY_URL,
  },
} = getConfig();

export const parseAffiliate = (affiliate) => {
  const values = affiliate.trim().split('-');

  return {
    name: values[0] || null,
    code: values[1] || null,
    params: values.slice(2).join('|') || null,
  };
};

const parseAffiliateCookie = (cookie) => ({
  name: getCookieValue(cookie, 'name|', 'code|'),
  code: getCookieValue(cookie, 'code|', 'params|'),
  params: getCookieValue(cookie, 'params|'),
});

export const parseAffiliateURL = () => {
  if (typeof window === 'undefined') return null;

  const campaign = new URLSearchParams(window.location.search).get('utm_campaign') || '';
  const source = new URLSearchParams(window.location.search).get('utm_source') || '';

  if (!campaign || !source || source !== 'impact') return null;

  return parseAffiliate(decodeURI(campaign));
};

export const getAffiliateInfo = () => {
  const existingAffiliate = getCookie('affiliate');
  let affiliateInfo;

  if (existingAffiliate) {
    affiliateInfo = {
      ...parseAffiliateCookie(existingAffiliate),
      hasCookie: true,
    };
  } else {
    affiliateInfo = parseAffiliateURL();

    if (affiliateInfo?.params?.includes('content_partner')) return undefined;
  }

  return affiliateInfo;
};

export const buildShopifyPrinterUrl = () => {
  const collection = GF_DOTCOM_ENV === 'production' ? 'printers' : 'glowforge-printers';
  return `${GF_DOTCOM_SHOPIFY_URL}/collections/${collection}`;
};

export const parseReferralCookie = (cookie) => ({
  code: getCookieValue(cookie, 'code|', 'fbuy|'),
  name: getCookieValue(cookie, 'name|', 'code|'),
  shopUrl: buildShopifyPrinterUrl(),
  parameters: {
    fbuy: getCookieValue(cookie, 'fbuy|', 'fbshare|'),
    fbshare: getCookieValue(cookie, 'fbshare|', 'referrerId|'),
    referrerId: getCookieValue(cookie, 'referrerId|'),
  },
});

export const buildReferralInfo = (referrer = {}) => {
  const code = referrer.referralCode || referrer.code || '';

  return {
    name: referrer.name || '',
    code,
    shopUrl: buildShopifyPrinterUrl(),
  };
};

export const buildReferralCookieValue = (referrerName = '', referralCode = '') =>
  `name|${referrerName}code|${referralCode}fbuy|fbshare|referrerId|`;

export const setReferralCookie = (referrerName, referralCode) => {
  if (!referralCode) return;

  setCookie(
    'referral',
    buildReferralCookieValue(referrerName, referralCode),
    30,
    false,
  );
};

export const setAffiliateCookie = (affiliateInfo) => {
  if (!affiliateInfo?.code) return;

  setCookie(
    'affiliate',
    `name|${affiliateInfo.name}code|${affiliateInfo.code}params|${affiliateInfo.params}`,
    30,
    false,
  );
};

export const getReferralShareOrigin = () =>
  (GF_DOTCOM_ENV === 'production'
    ? 'https://share.glowforge.com'
    : 'https://share-staging.glowforge.com');

export const buildReferralShareUrl = (referralCode) =>
  `${getReferralShareOrigin()}/${referralCode}`;
